import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import { DocumentFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { FileListComponent } from '../FileList'

type Props = {
  docs: DocumentFile[] | undefined
  sampleRequestId: string
  sampleRequestRefetch: refetchFunc
}

export const SampleDocsByRegional: FC<Props> = ({ docs, sampleRequestId, sampleRequestRefetch }) => {
  const [removeDocProgress, removeDoc] = useAProgress(
    (fileId) => apiClient.delete(endpoints.sampleRequestDocuments(sampleRequestId, fileId)),
    {
      eventName: 'removeSampleRequestDoc',
      onSuccess: sampleRequestRefetch,
    },
  )

  return <FileListComponent deleteFile={removeDoc} files={docs} deleteProgress={removeDocProgress} />
}
